// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3WNeC","additionalInfo":"AgreementModal_additionalInfo__VL4GL"};